import React, { useEffect, useContext, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { CatalogosService } from "../../services/catalogos.service.js";
import { PostulanteService } from "../../services/postulantes.service.js";
import ModalContainer from "../../components/ModalContainer.tsx";
import DocUploadSlot from "../../components/result/DocUploadSlot.tsx";
import S3Service from "../../services/s3.service.ts";
import { notification } from "../../utils/Notifications.tsx";
import { readApplicationStatuses } from "../../services/applicationStatuses.service.ts";
import { readReason } from "../../services/reasons.service.ts";
import { getSchoolings } from "../../services/schooling.service.ts";
import { getShifts } from "../../services/shift.service.ts";
import { getVacancies } from "../../services/vacancy.service.ts";
import {
  approbePhase,
  rejectPhase,
  updateApplication,
  updateApplicationStatus,
} from "../../services/application.service.ts";
import {
  getLeaders,
  getLeaderAvailabilityByUser,
  getLeaderInterviews,
  createLeaderInterview,
} from "../../services/leader-availabilities.service.ts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import DeletePostulante from "../../components/postulantes/DeletePostulante.tsx";
import Loader from "../../components/Loader.tsx";
import Dropzone from "react-dropzone";
import { toCamelCase } from "../../hooks/toCameCase.tsx";
import imageCompression from "browser-image-compression";

registerLocale("es", es);

const INPUT_SHADOW =
  "0 1px 2px rgba(15, 23, 42, 0.05), 0 1px 3px rgba(15, 23, 42, 0.03)";

const resultFormStyles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    background: "transparent",
    paddingBottom: 88,
    position: "relative",
    zIndex: 1,
    boxSizing: "border-box",
  },
  pageInner: {
    width: "100%",
    maxWidth: "100%",
    margin: 0,
    padding: "20px 12px 32px",
    boxSizing: "border-box",
  },
  header: {
    margin: "0 0 12px",
    padding: "2px 0 6px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
  },
  backBtn: {
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    background: "#ffffff",
    color: "#334155",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.1)",
  },
  titleBlock: { flex: "1 1 220px", minWidth: 0 },
  title: { margin: 0, fontSize: 22, fontWeight: 700, color: "#1f2937" },
  subtitle: { margin: "4px 0 0", fontSize: 13, color: "#64748b" },
  formStack: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  section: {
    margin: 0,
    borderRadius: 14,
    overflow: "hidden",
    border: "1px solid #e8edf2",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 12px rgba(15, 23, 42, 0.06)",
  },
  sectionBody: {
    padding: "14px 16px 16px",
  },
  fieldsGridRow: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 12,
    marginBottom: 12,
  },
  fieldBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    minWidth: 0,
  },
  fieldLabel: {
    margin: 0,
    fontSize: 12,
    fontWeight: 600,
    color: "#475569",
    letterSpacing: "0.02em",
  },
  labeledRow: {
    display: "grid",
    gridTemplateColumns: "minmax(150px, 30%) 1fr",
    gap: "10px 14px",
    alignItems: "center",
    marginBottom: 12,
  },
  labeledRowTop: {
    alignItems: "start",
  },
  labeledRowLabel: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600,
    color: "#475569",
    textAlign: "right",
    lineHeight: 1.35,
  },
  actionsCard: {
    margin: 0,
    borderRadius: 14,
    border: "1px solid #e8edf2",
    backgroundColor: "#ffffff",
    padding: "14px 16px",
    boxShadow: "0 2px 12px rgba(15, 23, 42, 0.06)",
  },
  sectionHeaderBase: {
    padding: "12px 16px",
    color: "#ffffff",
    fontWeight: 700,
    fontSize: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  historialChip: {
    padding: "6px 12px",
    borderRadius: 999,
    background: "rgba(255,255,255,0.22)",
    color: "#ffffff",
    fontSize: 12,
    fontWeight: 600,
    border: "1px solid rgba(255,255,255,0.4)",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },
  docsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    gap: 14,
  },
  docSlot: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    minWidth: 0,
    padding: 14,
    borderRadius: 12,
    border: "1px solid #e8edf2",
    backgroundColor: "#f8fafc",
    boxShadow: INPUT_SHADOW,
  },
  docSlotLabel: {
    margin: 0,
    fontSize: 12,
    fontWeight: 600,
    color: "#475569",
    lineHeight: 1.35,
    wordBreak: "break-word",
  },
  statusChipGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    padding: "4px 0 8px",
  },
  statusChipHint: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600,
    color: "#64748b",
  },
  statusChipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
  },
  statusChipEmpty: {
    margin: 0,
    fontSize: 12,
    color: "#94a3b8",
    fontStyle: "italic",
  },
  rechazoPanel: {
    marginTop: 16,
    padding: "16px 18px",
    borderRadius: 12,
    border: "1px solid #fecaca",
    backgroundColor: "#fffbfb",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    boxShadow: INPUT_SHADOW,
  },
  rechazoPanelTitle: {
    margin: 0,
    fontSize: 14,
    fontWeight: 700,
    color: "#991b1b",
  },
  reasonChipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    alignItems: "center",
  },
};

const ENTREVISTADO_STATUS_OPTIONS = ["Aceptado", "Rechazado", "Cartera"];

function getReasonChipButtonStyle(selected) {
  return {
    padding: "8px 16px",
    borderRadius: 999,
    border: `2px solid ${selected ? "#dc2626" : "#e2e8f0"}`,
    background: selected ? "#dc2626" : "#ffffff",
    color: selected ? "#ffffff" : "#475569",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: selected
      ? "0 2px 6px rgba(220, 38, 38, 0.2)"
      : INPUT_SHADOW,
    transition: "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    maxWidth: "100%",
    textAlign: "left",
  };
}

function getStatusChipButtonStyle(statusName, selected) {
  const palette = {
    Aceptado: {
      color: "#3d7a42",
      bg: "#f0fdf4",
      border: "#b8e6ba",
      activeBg: "#72B56F",
    },
    Rechazado: {
      color: "#b91c1c",
      bg: "#fef2f2",
      border: "#fca5a5",
      activeBg: "#dc2626",
    },
    Cartera: {
      color: "#475569",
      bg: "#f8fafc",
      border: "#cbd5e1",
      activeBg: "#64748b",
    },
  };
  const c = palette[statusName] || palette.Cartera;

  return {
    padding: "10px 22px",
    borderRadius: 999,
    border: `2px solid ${selected ? c.activeBg : c.border}`,
    background: selected ? c.activeBg : c.bg,
    color: selected ? "#ffffff" : c.color,
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: selected
      ? "0 2px 8px rgba(15, 23, 42, 0.12)"
      : INPUT_SHADOW,
    transition: "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
  };
}

function getStatusHeaderGradient(statusName) {
  const map = {
    Solicitado: "linear-gradient(135deg, #50B7C0 0%, #3d9aa3 100%)",
    Entrevistado: "linear-gradient(135deg, #F5D76E 0%, #E0B020 100%)",
    Aceptado: "linear-gradient(135deg, #72B56F 0%, #5D9E5A 100%)",
    "Entrevista con Lider":
      "linear-gradient(135deg, #1E90FF 0%, #1565c0 100%)",
    "Pre-Colaborador":
      "linear-gradient(135deg, #FFA500 0%, #e69500 100%)",
    Rechazado: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
    Cartera: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
  };
  return (
    map[statusName] ||
    "linear-gradient(135deg, #50B7C0 0%, #3d9aa3 100%)"
  );
}

function getStatusBadgeStyle(statusName) {
  const map = {
    Solicitado: { color: "#2d8a93", bg: "#e8f7f8", border: "#a5e8ec" },
    Entrevistado: { color: "#7a6200", bg: "#fffbeb", border: "#F5D76E" },
    Aceptado: { color: "#3d7a42", bg: "#eef7ee", border: "#b8e6ba" },
    "Entrevista con Lider": {
      color: "#0369a1",
      bg: "#ecfeff",
      border: "#a5f3fc",
    },
    "Pre-Colaborador": {
      color: "#ffffff",
      bg: "#FFA500",
      border: "#FFA500",
    },
    Rechazado: { color: "#b91c1c", bg: "#fef2f2", border: "#fecaca" },
    Cartera: { color: "#475569", bg: "#f8fafc", border: "#e2e8f0" },
  };
  const c = map[statusName] || map.Solicitado;
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 18px",
    borderRadius: 999,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "0.02em",
    color: c.color,
    backgroundColor: c.bg,
    border: `1.5px solid ${c.border}`,
    flexShrink: 0,
    minHeight: 36,
  };
}

function ResultSection({ children, style, className = "" }) {
  const sectionClass = ["result-form-section", className].filter(Boolean).join(" ");
  return (
    <div
      className={sectionClass}
      style={{ ...resultFormStyles.section, ...style }}
    >
      {children}
    </div>
  );
}

function ResultSectionHeader({ children, statusName = "" }) {
  return (
    <div
      style={{
        ...resultFormStyles.sectionHeaderBase,
        background: getStatusHeaderGradient(statusName),
      }}
    >
      {children}
    </div>
  );
}

function ResultSectionBody({ children }) {
  return <div style={resultFormStyles.sectionBody}>{children}</div>;
}

function getControlStyle(disabled) {
  return {
    height: 44,
    borderRadius: 10,
    border: "1px solid #e2e8f0",
    fontSize: 14,
    width: "100%",
    boxSizing: "border-box",
    padding: "0 12px",
    backgroundColor: disabled ? "#f8fafc" : "#ffffff",
    color: disabled ? "#64748b" : "#1f2937",
    boxShadow: INPUT_SHADOW,
  };
}

function getFileInputStyle() {
  return {
    width: "100%",
    maxWidth: "100%",
    fontSize: 12,
    borderRadius: 10,
    border: "1px solid #e2e8f0",
    padding: "8px 10px",
    backgroundColor: "#ffffff",
    color: "#64748b",
    boxShadow: INPUT_SHADOW,
    cursor: "pointer",
    boxSizing: "border-box",
  };
}

function getTextareaStyle(disabled) {
  return {
    ...getControlStyle(disabled),
    height: "auto",
    minHeight: 88,
    padding: "10px 12px",
    resize: "vertical",
    lineHeight: 1.45,
  };
}

function ResultFormUiStyles() {
  return (
    <style>{`
      .result-form-ui.result-form-stack fieldset {
        border: none;
        padding: 0;
        margin: 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
      .result-form-ui .form-control:focus,
      .result-form-ui .form-select:focus,
      .result-form-ui textarea:focus {
        border-color: #50B7C0 !important;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05),
          0 0 0 3px rgba(80, 183, 192, 0.2) !important;
        outline: none;
      }
      .result-form-ui textarea.result-form-input-like {
        height: 44px !important;
        min-height: 44px !important;
        padding: 10px 12px !important;
        line-height: 22px !important;
        resize: none;
        overflow-y: auto;
      }
      .result-form-ui .result-form-file-input::file-selector-button {
        margin-right: 10px;
        padding: 6px 12px;
        border: none;
        border-radius: 8px;
        background: #50b7c0;
        color: #ffffff;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
      }
      .result-form-ui .result-form-file-input::file-selector-button:hover {
        background: #3d9aa3;
      }
      @media (max-width: 1200px) {
        .result-form-ui .result-form-docs-grid {
          grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        }
      }
      @media (max-width: 767px) {
        .result-form-ui .result-form-docs-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        }
      }
      @media (max-width: 480px) {
        .result-form-ui .result-form-docs-grid {
          grid-template-columns: 1fr !important;
        }
      }
      @media (max-width: 991px) {
        .result-form-ui .result-form-fields-row {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        }
      }
      @media (max-width: 767px) {
        .result-form-ui .result-form-fields-row {
          grid-template-columns: 1fr !important;
        }
        .result-form-ui .result-form-labeled-row {
          grid-template-columns: 1fr !important;
        }
        .result-form-ui .result-form-labeled-row b {
          text-align: left !important;
        }
        .result-form-ui .result-form-status-chips {
          flex-direction: column;
          align-items: stretch !important;
        }
        .result-form-ui .result-form-status-chip {
          width: 100%;
          justify-content: center;
        }
      }
      .result-form-ui .result-form-status-chip:hover {
        filter: brightness(0.97);
      }
      .result-form-ui .result-form-status-chip:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(80, 183, 192, 0.35) !important;
      }
      .result-form-ui .result-form-reason-chip:hover {
        filter: brightness(0.98);
      }
      .result-form-ui .result-form-reason-chip:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25) !important;
      }
      @media (max-width: 767px) {
        .result-form-ui .result-form-reason-chips {
          flex-direction: column;
          align-items: stretch !important;
        }
        .result-form-ui .result-form-reason-chip {
          width: 100%;
          justify-content: center;
        }
      }
    `}</style>
  );
}

function FormResult({ route }) {
  const navigate = useNavigate();
  const context = useContext(AppSettings);
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [schoolings, setSchoolings] = useState([]);
  const [positions, setPositions] = useState([]);
  const [shifts, setShifts] = useState([]);

  const [perfil, setPerfil] = useState(null);
  const [perfilUrl, setPerfilUrl] = useState(null);
  const [ine, setIne] = useState(null);
  const [ine1, setIne1] = useState(null);
  const [ineUrl, setIneUrl] = useState(null);
  const [ine1Url, setIne1Url] = useState(null);
  const [domicilio, setDomicilio] = useState(null);
  const [domicilioUrl, setDomicilioUrl] = useState(null);
  const [solicitud, setSolicitud] = useState(null);
  const [solicitudUrl, setSolicitudUrl] = useState(null);
  const [psicometrics, setPsicometrics] = useState([]);
  const [psicometricsUrl, setPsicometricsUrl] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [docPreviewModal, setDocPreviewModal] = useState({
    open: false,
    title: "",
    src: "",
  });

  const [status, setStatus] = useState("");
  const [reasons, setReasons] = useState([]);
  const [reason, setReason] = useState("");
  const [applicationStatuses, setApplicationStatuses] = useState([]);

  // Leader Interview State
  const [interviewCheck, setInterviewCheck] = useState(false);
  const [leaders, setLeaders] = useState([]);
  const [selectedLeader, setSelectedLeader] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [leaderAvailabilities, setLeaderAvailabilities] = useState([]);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [leaderInterviews, setLeaderInterviews] = useState([]);

  const [isDisabled, setIsDisabled] = useState(
    location.state.applicationStatus.name !== "Solicitado"
  );

  // Función para comprimir imágenes
  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 1, // Máximo 1MB
      maxWidthOrHeight: 1920, // Máximo 1920px de ancho o alto
      useWebWorker: true,
      fileType: "image/jpeg", // Convertir a JPEG para mejor compresión
      quality: 0.8, // 80% de calidad
    };

    try {
      const compressedFile = await imageCompression(file, options);
      console.log("Tamaño original:", file.size / 1024 / 1024, "MB");
      console.log(
        "Tamaño comprimido:",
        compressedFile.size / 1024 / 1024,
        "MB"
      );
      return compressedFile;
    } catch (error) {
      console.error("Error comprimiendo imagen:", error);
      return file; // Retornar archivo original si falla la compresión
    }
  };
  useEffect(() => {
    dependecies();

    fetchImages();

    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("");

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
    };
    // eslint-disable-next-line
  }, []);

  const dependecies = async () => {
    try {
      const positions = await getVacancies();
      setPositions(positions);

      const schoolings = await getSchoolings();
      setSchoolings(schoolings);

      const shifts = await getShifts();
      setShifts(shifts);

      const applicationStatuses = await readApplicationStatuses();
      setApplicationStatuses(applicationStatuses);

      const reasons = await readReason();
      setReasons(reasons);
    } catch (error) {
      notification("Ocurrio un error!", error.message, "danger");
      console.log(error);
    }
  };

  useEffect(() => {
    if (interviewCheck && leaders.length === 0) {
      getLeaders()
        .then((data) => setLeaders(data || []))
        .catch(console.error);
    }
  }, [interviewCheck]);

  useEffect(() => {
    if (!selectedLeader) {
      setLeaderAvailabilities([]);
      setLeaderInterviews([]);
      return;
    }

    const fetchData = async () => {
      try {
        const avails = await getLeaderAvailabilityByUser(selectedLeader);
        const interviews = await getLeaderInterviews(selectedLeader);
        setLeaderAvailabilities(avails || []);
        setLeaderInterviews(interviews || []);
        setSelectedDate(null);
        setAvailableSlots([]);
        setSelectedSlot("");
      } catch (e) {
        console.error(e);
      }
    };
    fetchData();
  }, [selectedLeader]);

  useEffect(() => {
    if (!selectedDate || !selectedLeader) return;

    const dateStr = moment(selectedDate).format("YYYY-MM-DD");

    const dayAvails = leaderAvailabilities.filter((a) =>
      moment(a.startTime).isSame(dateStr, "day")
    );

    let slots = [];

    dayAvails.forEach((av) => {
      const start = moment(av.startTime);
      const end = moment(av.endTime);

      let current = start.clone();
      while (current.isBefore(end)) {
        const slotTime = current.format("HH:mm");

        const isTaken = leaderInterviews.some((interview) => {
          const intStart = moment(interview.startTime);
          const intEnd = moment(interview.endTime);
          const slotEnd = current.clone().add(15, "minutes");

          return current.isBefore(intEnd) && slotEnd.isAfter(intStart);
        });

        if (!isTaken) {
          slots.push(slotTime);
        }

        current.add(15, "minutes");
      }
    });

    slots = [...new Set(slots)].sort();
    setAvailableSlots(slots);
  }, [selectedDate, leaderAvailabilities, leaderInterviews]);

  const fetchImages = async () => {
    try {
      const profileUrl = await S3Service.getFile(
        "PERFIL_" + location.state.person.curp
      );
      setPerfilUrl(profileUrl.url);
      const ineUrl = await S3Service.getFile(
        "INE_" + location.state.person.curp
      );
      setIneUrl(ineUrl.url);
      const ine1Url = await S3Service.getFile(
        "INE_1_" + location.state.person.curp
      );
      setIne1Url(ine1Url.url);
      const domicilioUrl = await S3Service.getFile(
        "DOMICILIO_" + location.state.person.curp
      );
      setDomicilioUrl(domicilioUrl.url);
      const solicitudUrl = await S3Service.getFile(
        "SOLICITUD_" + location.state.person.curp
      );
      setSolicitudUrl(solicitudUrl.url);

      const psicometricsUrl = await S3Service.getFiles(
        "PSICOMETRICO_" + location.state.person.curp
      );
      setPsicometricsUrl(psicometricsUrl);
    } catch (error) {
      console.log(error);
    }
  };

  const handleStatusSelect = (value) => {
    setStatus(value);
    if (value !== "Rechazado") {
      setReason("");
    }
  };

  const handleReasonSelect = (reasonId) => {
    setReason(reasonId);
  };

  const handlePerfilChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const compressedFile = await compressImage(file);
      setPerfil(compressedFile);
    }
  };

  const handleIneChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const compressedFile = await compressImage(file);
      setIne(compressedFile);
    }
  };

  const handleIne1Change = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const compressedFile = await compressImage(file);
      setIne1(compressedFile);
    }
  };

  const handleDomicilioChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const compressedFile = await compressImage(file);
      setDomicilio(compressedFile);
    }
  };

  const handleSolicitudChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const compressedFile = await compressImage(file);
      setSolicitud(compressedFile);
    }
  };

  const openDocPreview = (src, title) => {
    setDocPreviewModal({ open: true, src, title });
  };

  const selectDocFile = async (setter, file) => {
    const compressedFile = await compressImage(file);
    setter(compressedFile);
  };

  const handleFileChange = async (acceptedFiles) => {
    const validImages = [];
    const invalidFiles = [];

    for (const file of acceptedFiles) {
      if (file.type.startsWith("image/")) {
        const compressedFile = await compressImage(file);
        validImages.push(compressedFile);
      } else {
        invalidFiles.push(file);
        notification("Error", "Solo se permiten imágenes", "danger");
      }
    }

    setPsicometrics([...psicometrics, ...validImages]);
  };

  const handleDelete = (index) => {
    const newPsicometrics = [...psicometrics];
    newPsicometrics.splice(index, 1);
    setPsicometrics(newPsicometrics);
  };

  const handleSubmit = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    /*
    if (Boolean(psicometrics.length === 0) && !isDisabled) {
    
      notification(
        "Error",
        "Se requiere al menos una prueba psicométrica",
        "danger"
      );
      setIsLoading(false);
      return;
    }
    */
    let operation;
    let body = {};
    if (location.state.applicationStatus.name == "Solicitado") {
      operation = "fill_out";

      body.personId = location.state.id_person;
      body.curp = location.state.person.curp;
      body.firstName = event.target.firstName.value;
      body.lastName = event.target.lastName.value;
      body.secondLastName = event.target.secondLastName.value;
      body.birthdate = event.target.birthdate.value;
      body.phone = event.target.phone.value;

      for (let index = 0; index < schoolings.length; index++) {
        if (schoolings[index].name == event.target.schoolingId.value) {
          body.schoolingId = schoolings[index].id;
          index = schoolings.length;
        }
      }

      body.address = event.target.address.value;
      body.positionId = event.target.positionId.value;

      // }

      body.monthlySalary = event.target.monthlySalary.value;
      body.stayingMonths = event.target.stayingMonths.value;

      for (let index = 0; index < shifts.length; index++) {
        if (shifts[index].name == event.target.shiftId.value) {
          body.shiftId = shifts[index].id;
          index = shifts.length;
        }
      }

      body.experience = event.target.experience.value;
      body.children = event.target.children.value;
      body.health = event.target.health.value;
      body.diseases = event.target.diseases.value;

      body.applicationDate = location.state.application_date;
      body.applicationTime = location.state.application_time;
      // body.applicationStatusId = location.state.id_application_status;

      // Key: "PERFIL_" + location.state.person.curp,
      // Key: "INE_" + location.state.person.curp,
      // Key: "DOMICILIO_" + location.state.person.curp,
      // Key: "SOLICITUD_" + location.state.person.curp,

      try {
        const profile = await S3Service.upload(
          perfil,
          "PERFIL_" + location.state.person.curp
        );
        const ineS3 = await S3Service.upload(
          ine,
          "INE_" + location.state.person.curp
        );
        const ine1S3 = await S3Service.upload(
          ine1,
          "INE_1_" + location.state.person.curp
        );
        const domiclioS3 = await S3Service.upload(
          domicilio,
          "DOMICILIO_" + location.state.person.curp
        );
        const solicitudS3 = await S3Service.upload(
          solicitud,
          "SOLICITUD_" + location.state.person.curp
        );

        // Upload psicometrics using promise.all
        // const psicometricsS3 = await Promise.all(
        //   psicometrics.map((file, index) => {
        //     return S3Service.upload(
        //       file,
        //       "PSICOMETRICO_" + location.state.person.curp + "_" + index
        //     );
        //   })
        // );
        // console.log("psicometricsS3", psicometricsS3);
      } catch (error) {
        console.log(error);
      }

      // return;
    } else if (location.state.applicationStatus.name == "Entrevistado") {
      if (!status) {
        notification(
          "Atención",
          "Seleccione un status para continuar",
          "warning"
        );
        setIsLoading(false);
        return;
      }

      // Si el array de psicometricas tiene algo subirlos
      if (psicometrics.length > 0) {
        // Upload psicometrics using promise.all
        const psicometricsS3 = await Promise.all(
          psicometrics.map((file, index) => {
            return S3Service.upload(
              file,
              "PSICOMETRICO_" + location.state.person.curp + "_" + index
            );
          })
        );
      }

      if (status == "Aceptado") {
        operation = "approve";

        // --- Interview Creation ---
        if (interviewCheck) {
          if (!selectedLeader || !selectedDate || !selectedSlot) {
            notification(
              "Atención",
              "Debe completar la agenda de entrevista con el líder",
              "warning"
            );
            setIsLoading(false);
            return;
          }
          try {
            // Construct Date objects
            const [hour, minute] = selectedSlot.split(":").map(Number);
            const startTime = moment(selectedDate)
              .hour(hour)
              .minute(minute)
              .second(0);
            const endTime = startTime.clone().add(15, "minutes"); // 15 min duration

            await createLeaderInterview({
              leaderId: Number(selectedLeader),
              applicationId: Number(location.state.id),
              startTime: startTime.format(), // ISO string
              endTime: endTime.format(),
            });
            notification(
              "Éxito",
              "Entrevista con líder agendada correctamente",
              "success"
            );
          } catch (e) {
            console.error(e);
            notification(
              "Error",
              "Error al agendar entrevista con líder",
              "danger"
            );
            setIsLoading(false);
            return;
          }
        }
        // --------------------------
      } else if (status == "Rechazado") {
        if (!reason) {
          notification(
            "Atención",
            "Seleccione un motivo de rechazo",
            "warning"
          );
          setIsLoading(false);
          return;
        }
        operation = "reject";
        body.reasonId = reason;
        body.comments = event.target.comments.value;
      }
    }

    if (status == "Aceptado") {
      try {
        const response = await approbePhase(location.state.id);
      } catch (error) {
        console.log("Error!!", error);
      }
    } else if (status == "Rechazado") {
      console.log(location.state.id, body);
      try {
        const response = await rejectPhase(location.state.id, body);
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    } else if (status == "Cartera") {
      try {
        const carteraStatus = applicationStatuses.find(
          (s) => s.name === "Cartera"
        );
        if (!carteraStatus) {
          notification(
            "Error",
            "No se encontró el status 'Cartera' en el catálogo",
            "danger"
          );
        } else {
          await updateApplicationStatus(location.state.id, carteraStatus.id);
        }
      } catch (error) {
        console.log(error);
        notification(
          "Ocurrió un error al cambiar a status Cartera",
          error.message || "Error desconocido",
          "danger"
        );
      }
    } else {
      try {
        const response = await updateApplication(
          location.state.id,
          body,
          operation
        );
      } catch (error) {
        console.log(error);
        notification("Ocurrio un error!", error.message, "danger");
      }
    }

    // console.log(location.state.id, body, operation);
    setIsLoading(false);

    // return;

    setRedirect(true);

    return;
    await PostulanteService.updateApplication(
      location.state.id,
      operation,
      body
    );
  };

  if (redirect) {
    return <Navigate to="/solicitudes" />;
  }

  const handleCancel = async () => {
    try {
      // console.log(location.state.id);
      // const response = await PostulanteService.cancelApplication(
      //   location.state.id
      // );
      // console.log(response);
    } catch (error) {
      console.log(error);
    }
  };
  const statusName = location.state.applicationStatus?.name || "";
  const candidateName = toCamelCase(
    `${location.state.person.firstName} ${location.state.person.lastName}${
      location.state.person.secondLastName
        ? ` ${location.state.person.secondLastName}`
        : ""
    }`
  );

  return (
    <div style={resultFormStyles.page}>
      <div style={resultFormStyles.pageInner}>
        <header style={resultFormStyles.header}>
          <button
            type="button"
            aria-label="Regresar"
            style={resultFormStyles.backBtn}
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-arrow-left" aria-hidden />
          </button>
          <div style={resultFormStyles.titleBlock}>
            <h1 style={resultFormStyles.title}>{candidateName}</h1>
            <p style={resultFormStyles.subtitle}>
              Solicitud #{location.state.id} · Revisión de postulante
            </p>
          </div>
          <span style={getStatusBadgeStyle(statusName)}>{statusName}</span>
        </header>

        <ResultFormUiStyles />
        <form
          onSubmit={handleSubmit}
          key={location.state.id}
          className="fs-13px result-form-ui result-form-stack"
          style={resultFormStyles.formStack}
        >
          <ResultSection>
            <ResultSectionHeader statusName={statusName}>
              <span>Datos generales</span>
              <button
                type="button"
                style={resultFormStyles.historialChip}
                onClick={() =>
                  navigate(
                    `/postulante/historial/${location.state.person.curp}`
                  )
                }
              >
                Revisar historial <i className="fa-solid fa-file" />
              </button>
            </ResultSectionHeader>
            <ResultSectionBody>
              <div
                className="result-form-fields-row"
                style={resultFormStyles.fieldsGridRow}
              >
                <div style={resultFormStyles.fieldBlock}>
                  <label htmlFor="firstName" style={resultFormStyles.fieldLabel}>
                    Nombre(s) *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="firstName"
                    name="firstName"
                    defaultValue={toCamelCase(location.state.person.firstName)}
                    disabled={isDisabled}
                    required
                    style={getControlStyle(isDisabled)}
                  />
                </div>
                <div style={resultFormStyles.fieldBlock}>
                  <label htmlFor="lastName" style={resultFormStyles.fieldLabel}>
                    Apellido paterno *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="lastName"
                    name="lastName"
                    defaultValue={toCamelCase(location.state.person.lastName)}
                    disabled={isDisabled}
                    required
                    style={getControlStyle(isDisabled)}
                  />
                </div>
                <div style={resultFormStyles.fieldBlock}>
                  <label
                    htmlFor="secondLastName"
                    style={resultFormStyles.fieldLabel}
                  >
                    Apellido materno *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="secondLastName"
                    name="secondLastName"
                    defaultValue={toCamelCase(
                      location.state.person.secondLastName
                    )}
                    disabled={isDisabled}
                    required
                    style={getControlStyle(isDisabled)}
                  />
                </div>
              </div>
              <div
                className="result-form-fields-row"
                style={resultFormStyles.fieldsGridRow}
              >
                <div style={resultFormStyles.fieldBlock}>
                  <label htmlFor="birthdate" style={resultFormStyles.fieldLabel}>
                    Fecha de nacimiento
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="birthdate"
                    name="birthdate"
                    defaultValue={location.state.person.birthdate}
                    disabled={isDisabled}
                    style={getControlStyle(isDisabled)}
                  />
                </div>
                <div style={resultFormStyles.fieldBlock}>
                  <label htmlFor="phone" style={resultFormStyles.fieldLabel}>
                    Teléfono *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    name="phone"
                    defaultValue={location.state.person.phone}
                    disabled={isDisabled}
                    required
                    style={getControlStyle(isDisabled)}
                  />
                </div>
                <div style={resultFormStyles.fieldBlock}>
                  <label htmlFor="schoolingId" style={resultFormStyles.fieldLabel}>
                    Escolaridad *
                  </label>
                  <select
                    className="form-select"
                    id="schoolingId"
                    name="schoolingId"
                    required
                    disabled={isDisabled}
                    style={getControlStyle(isDisabled)}
                  >
                    {schoolings.map((item) => {
                      const selected =
                        location.state.person.schooling.id == item.id
                          ? "selected"
                          : "";
                      return (
                        <option
                          key={item.id}
                          value={item.name}
                          selected={selected}
                          disabled={isDisabled}
                        >
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div style={resultFormStyles.fieldBlock}>
                <label htmlFor="address" style={resultFormStyles.fieldLabel}>
                  Domicilio (calle, número, colonia, CP) *
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="address"
                  name="address"
                  defaultValue={location.state.person.address}
                  disabled={isDisabled}
                  required
                  style={getControlStyle(isDisabled)}
                />
              </div>
            </ResultSectionBody>
          </ResultSection>

          <ResultSection>
            <ResultSectionHeader statusName={statusName}>
              Información de la solicitud
            </ResultSectionHeader>
            <ResultSectionBody>
              <div
                className="result-form-labeled-row"
                style={resultFormStyles.labeledRow}
              >
                <b style={resultFormStyles.labeledRowLabel}>Puesto *</b>
                <select
                  className="form-select"
                  id="positionId"
                  name="positionId"
                  required
                  disabled={isDisabled}
                  style={getControlStyle(isDisabled)}
                >
                  {positions.map((item) => {
                    const selected =
                      location.state.vacancy.position.id == item.position.id
                        ? true
                        : false;
                    return (
                      <option
                        key={item.position.id}
                        value={item.position.id}
                        selected={selected}
                        disabled={isDisabled}
                      >
                        {item.position.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div
                className="result-form-labeled-row"
                style={resultFormStyles.labeledRow}
              >
                <b style={resultFormStyles.labeledRowLabel}>
                  Expectativa salarial al mes *
                </b>
                <input
                  type="number"
                  className="form-control"
                  id="monthlySalary"
                  name="monthlySalary"
                  defaultValue={location.state.monthlySalary}
                  disabled={isDisabled}
                  min="0"
                  required
                  style={getControlStyle(isDisabled)}
                />
              </div>
              <div
                className="result-form-labeled-row"
                style={resultFormStyles.labeledRow}
              >
                <b style={resultFormStyles.labeledRowLabel}>
                  Expectativa de permanencia *
                </b>
                <input
                  type="text"
                  className="form-control"
                  id="stayingMonths"
                  name="stayingMonths"
                  defaultValue={
                    location.state.stayingMonthsRange ||
                    (location.state.stayingMonths
                      ? `${location.state.stayingMonths} meses`
                      : "")
                  }
                  disabled={isDisabled}
                  required
                  style={getControlStyle(isDisabled)}
                />
              </div>
              <div
                className="result-form-labeled-row"
                style={resultFormStyles.labeledRow}
              >
                <b style={resultFormStyles.labeledRowLabel}>
                  Preferencia de turno *
                </b>
                <select
                  className="form-select"
                  id="shiftId"
                  name="shiftId"
                  required
                  disabled={isDisabled}
                  style={getControlStyle(isDisabled)}
                >
                  {shifts.map((item) => {
                    const selected =
                      location.state.shift.id == item.id ? "selected" : "";
                    return (
                      <option
                        key={item.id}
                        value={item.name}
                        selected={selected}
                        disabled={isDisabled}
                      >
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div
                className="result-form-labeled-row"
                style={resultFormStyles.labeledRow}
              >
                <b style={resultFormStyles.labeledRowLabel}>
                  Preferencia de lugar
                </b>
                <input
                  type="text"
                  className="form-control"
                  value={
                    location.state.preferenciaLugarTipo ||
                    "Sin preferencia registrada"
                  }
                  disabled
                  style={getControlStyle(true)}
                />
              </div>
              <div
                className="result-form-labeled-row"
                style={resultFormStyles.labeledRow}
              >
                <b style={resultFormStyles.labeledRowLabel}>
                  Sucursal preferente
                </b>
                <input
                  type="text"
                  className="form-control"
                  value={
                    location.state.preferenciaSucursal?.name ||
                    "Sin sucursal o planta registrada"
                  }
                  disabled
                  style={getControlStyle(true)}
                />
              </div>
              <div
                className="result-form-labeled-row result-form-labeled-row--top"
                style={{
                  ...resultFormStyles.labeledRow,
                  ...resultFormStyles.labeledRowTop,
                  marginBottom: 0,
                }}
              >
                <b style={resultFormStyles.labeledRowLabel}>Experiencia *</b>
                <textarea
                  rows={4}
                  className="form-control"
                  id="experience"
                  name="experience"
                  defaultValue={location.state.experience}
                  disabled={isDisabled}
                  required
                  style={{
                    ...getTextareaStyle(isDisabled),
                    minHeight: 120,
                  }}
                />
              </div>
            </ResultSectionBody>
          </ResultSection>

          <ResultSection>
            <ResultSectionHeader statusName={statusName}>
              Datos personales
            </ResultSectionHeader>
            <ResultSectionBody>
              <div
                className="result-form-labeled-row"
                style={resultFormStyles.labeledRow}
              >
                <b style={resultFormStyles.labeledRowLabel}>Hijos *</b>
                <textarea
                  rows={1}
                  className="form-control result-form-input-like"
                  id="children"
                  name="children"
                  defaultValue={location.state.children}
                  disabled={isDisabled}
                  required
                  style={getControlStyle(isDisabled)}
                />
              </div>
              <div
                className="result-form-labeled-row"
                style={resultFormStyles.labeledRow}
              >
                <b style={resultFormStyles.labeledRowLabel}>Estado de salud *</b>
                <textarea
                  rows={1}
                  className="form-control result-form-input-like"
                  id="health"
                  name="health"
                  defaultValue={location.state.health}
                  disabled={isDisabled}
                  required
                  style={getControlStyle(isDisabled)}
                />
              </div>
              <div
                className="result-form-labeled-row"
                style={{ ...resultFormStyles.labeledRow, marginBottom: 0 }}
              >
                <b style={resultFormStyles.labeledRowLabel}>
                  Enfermedades crónicas *
                </b>
                <textarea
                  rows={1}
                  className="form-control result-form-input-like"
                  id="diseases"
                  name="diseases"
                  defaultValue={location.state.diseases}
                  disabled={isDisabled}
                  required
                  style={getControlStyle(isDisabled)}
                />
              </div>
            </ResultSectionBody>
          </ResultSection>

          <ResultSection>
            <ResultSectionHeader statusName={statusName}>
              Documentación
            </ResultSectionHeader>
            <ResultSectionBody>
              <div
                className="result-form-docs-grid"
                style={resultFormStyles.docsGrid}
              >
                {location.state.applicationStatus.name === "Solicitado" ? (
                  <>
                    <DocUploadSlot
                      label="Imagen de Perfil"
                      inputId="perfil"
                      required
                      file={perfil}
                      canEdit
                      onFileSelect={(f) => selectDocFile(setPerfil, f)}
                      onRemove={() => setPerfil(null)}
                      onPreview={openDocPreview}
                    />
                    <DocUploadSlot
                      label="Identificación Oficial Frente"
                      inputId="ine"
                      required
                      file={ine}
                      canEdit
                      onFileSelect={(f) => selectDocFile(setIne, f)}
                      onRemove={() => setIne(null)}
                      onPreview={openDocPreview}
                    />
                    <DocUploadSlot
                      label="Identificación Oficial Posterior"
                      inputId="ine1"
                      required
                      file={ine1}
                      canEdit
                      onFileSelect={(f) => selectDocFile(setIne1, f)}
                      onRemove={() => setIne1(null)}
                      onPreview={openDocPreview}
                    />
                    <DocUploadSlot
                      label="Comprobante de domicilio"
                      inputId="domicilio"
                      required
                      file={domicilio}
                      canEdit
                      onFileSelect={(f) => selectDocFile(setDomicilio, f)}
                      onRemove={() => setDomicilio(null)}
                      onPreview={openDocPreview}
                    />
                    <DocUploadSlot
                      label="Solicitud de empleo"
                      inputId="solicitud"
                      required
                      file={solicitud}
                      canEdit
                      onFileSelect={(f) => selectDocFile(setSolicitud, f)}
                      onRemove={() => setSolicitud(null)}
                      onPreview={openDocPreview}
                    />
                  </>
                ) : (
                  <>
                    <DocUploadSlot
                      label="Imagen de Perfil"
                      inputId="perfil-view"
                      previewUrl={perfilUrl}
                      onFileSelect={() => {}}
                      onPreview={openDocPreview}
                    />
                    <DocUploadSlot
                      label="Identificación Oficial Frente"
                      inputId="ine-view"
                      previewUrl={ineUrl}
                      onFileSelect={() => {}}
                      onPreview={openDocPreview}
                    />
                    <DocUploadSlot
                      label="Identificación Oficial Posterior"
                      inputId="ine1-view"
                      previewUrl={ine1Url}
                      onFileSelect={() => {}}
                      onPreview={openDocPreview}
                    />
                    <DocUploadSlot
                      label="Comprobante de domicilio"
                      inputId="domicilio-view"
                      previewUrl={domicilioUrl}
                      onFileSelect={() => {}}
                      onPreview={openDocPreview}
                    />
                    <DocUploadSlot
                      label="Solicitud de empleo"
                      inputId="solicitud-view"
                      previewUrl={solicitudUrl}
                      onFileSelect={() => {}}
                      onPreview={openDocPreview}
                    />
                  </>
                )}
              </div>

              {location.state.applicationStatus.name !== "Solicitado" && (
                <React.Fragment>
                  <div className="row">
                    <div className="col-md-12">
                      <label className="form-label col-form-label">
                        Pruebas psicométricas
                      </label>
                      <Dropzone
                        accept={{
                          "image/png": [".png"],
                          "image/jpeg": [".jpg", ".jpeg"],
                          "image/jpg": [".jpg"],
                        }}
                        onDrop={(acceptedFiles) =>
                          handleFileChange(acceptedFiles)
                        }
                      >
                        {({ getRootProps, getInputProps }) => (
                          <section>
                            <div
                              {...getRootProps()}
                              className="dropzone-container border rounded p-4 text-center"
                            >
                              <input {...getInputProps()} />
                              <i className="fas fa-cloud-upload-alt fa-3x mb-3"></i>
                              <p className="mb-0">
                                Arrastra y suelta archivos aquí o haz clic para
                                seleccionar archivos
                              </p>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                      <div className="row">
                        {psicometrics.map((item, index) => {
                          // Verificar si el tipo de archivo comienza con "image/"
                          if (item.type.startsWith("image/")) {
                            return (
                              <div
                                key={index}
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  width: "min-content",
                                  backgroundColor: "#f5f6f7",
                                }}
                                className="d-flex m-2 rounded-2"
                              >
                                <button
                                  className="btn btn-danger btn-sm"
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    right: "0",
                                  }}
                                  onClick={() => handleDelete(index)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                                <img
                                  src={URL.createObjectURL(item)}
                                  alt="PSICOMETRICO"
                                  style={{
                                    width: "120px",
                                    height: "150px",
                                    objectFit: "contain",
                                    border: "1px solid #ddd",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  }}
                                />
                              </div>
                            );
                          } else {
                            //Render a div with the file name
                            return <div key={index}>{item.name}</div>;
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </ResultSectionBody>
          </ResultSection>

          {location.state.applicationStatus.name === "Entrevistado" && (
            <ResultSection>
              <ResultSectionHeader statusName={statusName}>
                Status
              </ResultSectionHeader>
              <ResultSectionBody>
                <div style={resultFormStyles.statusChipGroup}>
                  <p style={resultFormStyles.statusChipHint}>
                    Seleccione una opción para definir el nuevo status
                  </p>
                  <div
                    className="result-form-status-chips"
                    style={resultFormStyles.statusChipRow}
                    role="group"
                    aria-label="Status de la solicitud"
                  >
                    {ENTREVISTADO_STATUS_OPTIONS.map((optionName) => {
                      const isSelected = status === optionName;
                      return (
                        <button
                          key={optionName}
                          type="button"
                          className="result-form-status-chip"
                          style={getStatusChipButtonStyle(
                            optionName,
                            isSelected
                          )}
                          aria-pressed={isSelected}
                          onClick={() => handleStatusSelect(optionName)}
                        >
                          {isSelected ? (
                            <i className="fa fa-check" aria-hidden />
                          ) : null}
                          {optionName}
                        </button>
                      );
                    })}
                  </div>
                  {!status ? (
                    <p style={resultFormStyles.statusChipEmpty}>
                      Aún no has seleccionado un status
                    </p>
                  ) : null}
                  <input type="hidden" id="status" name="status" value={status} />
                </div>

                  {status === "Rechazado" ? (
                    <div
                      id="rechazo-panel"
                      style={resultFormStyles.rechazoPanel}
                    >
                      <p style={resultFormStyles.rechazoPanelTitle}>
                        Detalle del rechazo
                      </p>

                      <div style={resultFormStyles.fieldBlock}>
                        <p style={resultFormStyles.fieldLabel}>
                          Motivo de rechazo *
                        </p>
                        <div
                          className="result-form-reason-chips"
                          style={resultFormStyles.reasonChipRow}
                          role="group"
                          aria-label="Motivo de rechazo"
                        >
                          {reasons.map((item) => {
                            const isSelected = reason === item.id;
                            return (
                              <button
                                key={item.id}
                                type="button"
                                className="result-form-reason-chip"
                                style={getReasonChipButtonStyle(isSelected)}
                                aria-pressed={isSelected}
                                onClick={() => handleReasonSelect(item.id)}
                              >
                                {isSelected ? (
                                  <i className="fa fa-check" aria-hidden />
                                ) : null}
                                {item.name}
                              </button>
                            );
                          })}
                        </div>
                        {!reason ? (
                          <p style={resultFormStyles.statusChipEmpty}>
                            Seleccione un motivo para continuar
                          </p>
                        ) : null}
                        <input
                          type="hidden"
                          name="reasonId"
                          value={reason || ""}
                        />
                      </div>

                      <div style={resultFormStyles.fieldBlock}>
                        <label
                          htmlFor="comments"
                          style={resultFormStyles.fieldLabel}
                        >
                          Comentarios
                        </label>
                        <textarea
                          className="form-control result-form-input-like"
                          id="comments"
                          name="comments"
                          rows={3}
                          placeholder="Agrega detalles adicionales (opcional)"
                          style={getTextareaStyle(false)}
                        />
                      </div>
                    </div>
                  ) : null}

                  {/* {status === "Aceptado" && (
                    <div className="row mt-4 justify-content-center">
                        <div className="col-md-8">
                             <div className="form-check form-switch mb-3">
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    id="interviewCheck"
                                    checked={interviewCheck}
                                    onChange={(e) => setInterviewCheck(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="interviewCheck">¿Entrevista con Líder de Sucursal?</label>
                            </div>
                            
                            {interviewCheck && (
                                <div className="card p-3 bg-light">
                                    <h6 className="card-title">Agendar Entrevista</h6>
                                    
                                    <div className="mb-3">
                                        <label className="form-label">Seleccionar Líder</label>
                                        <select 
                                            className="form-select" 
                                            value={selectedLeader}
                                            onChange={e => setSelectedLeader(e.target.value)}
                                        >
                                            <option value="">Seleccione...</option>
                                            {leaders.map(l => (
                                                <option key={l.id} value={l.id}>{l.name} {l.lastName} ({l.branch?.name || "Sin sucursal"})</option>
                                            ))}
                                        </select>
                                    </div>

                                    {selectedLeader && (
                                        <div className="mb-3">
                                            <label className="form-label">Fecha</label>
                                            <DatePicker
                                                selected={selectedDate}
                                                onChange={(date) => setSelectedDate(date)}
                                                locale="es"
                                                dateFormat="yyyy-MM-dd"
                                                className="form-control"
                                                placeholderText="Seleccione una fecha"
                                                minDate={new Date()}
                                                filterDate={(date) => {
                                                    const dateStr = moment(date).format("YYYY-MM-DD");
                                                    return leaderAvailabilities.some(a => moment(a.startTime).isSame(dateStr, 'day'));
                                                }}
                                            />
                                        </div>
                                    )}

                                    {selectedDate && (
                                        <div className="mb-3">
                                             <label className="form-label">Horario Disponible (15 min)</label>
                                             <select 
                                                className="form-select"
                                                value={selectedSlot}
                                                onChange={e => setSelectedSlot(e.target.value)}
                                             >
                                                <option value="">Seleccione hora...</option>
                                                {availableSlots.length > 0 ? (
                                                    availableSlots.map(slot => (
                                                        <option key={slot} value={slot}>{slot}</option>
                                                    ))
                                                ) : (
                                                    <option disabled>No hay horarios disponibles</option>
                                                )}
                                             </select>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                  )} */}
              </ResultSectionBody>
            </ResultSection>
          )}

          <div style={resultFormStyles.actionsCard}>
              <div className="row noGutters">
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-warning h-45px w-75 btn-lg fs-14px"
                    onClick={() => {
                      setShowModal(true);
                      // console.log(location.state.id)
                      // navigate("/solicitudes")
                    }}
                    // Abrir modal y preguntar si quiere solo quiere cancelar la solicitud o si tambien quiere banearlo
                  >
                    Cancelar solicitud
                  </button>
                </div>
                {isLoading == true ? (
                  <center className="col">
                    <div class="loader"></div>
                  </center>
                ) : (
                  <div
                    className="col-md-6"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <button
                      type="submit"
                      className="btn btn-azul h-45px w-75 btn-lg fs-14px"
                      disabled={!psicometricsUrl || !psicometrics}
                    >
                      Guardar
                    </button>
                  </div>
                )}
              </div>
          </div>
        </form>
      </div>
      <div style={{ height: 75 }} />
      <div
        className="w-1000px h-75px"
        style={{
          backgroundImage: "url(../../../assets/img/footer/footer-chili.png)",
          backgroundRepeat: "repeat-x",
          position: "fixed",
          bottom: "0",
          left: "0",
          width: "100%",
          zIndex: 1,
        }}
      />
      <ModalContainer
        open={docPreviewModal.open}
        closeFn={() =>
          setDocPreviewModal({ open: false, title: "", src: "" })
        }
        title={docPreviewModal.title}
        size="lg"
      >
        <div style={{ textAlign: "center", padding: "8px 0" }}>
          <img
            src={docPreviewModal.src}
            alt={docPreviewModal.title}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
              borderRadius: 8,
            }}
          />
        </div>
      </ModalContainer>
      <ModalContainer
        open={showModal}
        closeFn={() => setShowModal(false)}
        title={`Cancelar solicitud de ${toCamelCase(
          location.state.person.firstName + " " + location.state.person.lastName
        )}`}
        children={
          <DeletePostulante
            id={location.state.id}
            name={`${toCamelCase(
              location.state.person.firstName +
                " " +
                location.state.person.lastName
            )}`}
            closeFn={() => setShowModal(false)}
            handleDelete={() => handleCancel()}
          />
        }
      />
      {/* isLoading */}
      <Loader isLoading={isLoading} />
    </div>
  );
}

export default FormResult;
